import _ from 'es-toolkit/compat';

import { DEFAULT_VALUE_IF_NIL } from '@clearverify/constants';
import { Nullable } from '@clearverify/types';

import { VerificationRequestStatus, VerificationRequestType } from 'src/api';
import { VERIFICATION_REQUEST_TYPE_SHORT_LABEL } from 'src/constants/verificationRequest';

export const getVerificationTypeLabel = (type: Nullable<VerificationRequestType>) => {
  return type
    ? VERIFICATION_REQUEST_TYPE_SHORT_LABEL[type] || DEFAULT_VALUE_IF_NIL
    : DEFAULT_VALUE_IF_NIL;
};

export const isVerificationRequestStatus = (value: unknown): value is VerificationRequestStatus => {
  if (!value) return false;
  return _.isString(value) && Object.values(VerificationRequestStatus as object).includes(value);
};
